
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.projectName"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!--    <div class="table-operator">-->
    <!--      <a-button @click="$refs.projectStaffAddOrUpdate.init('','add')" icon="plus" type="primary">新建</a-button>-->
    <!--    </div>-->
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.projectId"
    >
    </s-table>
    <projectStaff-add-or-update
      @ok="queryPage"
      ref="projectStaffAddOrUpdate"
    />
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/common/ProjectStaff'
import projectStaffAddOrUpdate from './ProjectStaffAddOrUpdate'
import { enterEvent } from '@/utils/util'
export default {
  name: 'ProjectStaffView',
  mixins: [TableMixin],
  components: {
    projectStaffAddOrUpdate
  },
  data () {
    return {
      description: '给项目分配相关人员',
      queryParam: {
        test: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        // {
        //   title: '主键',
        //   dataIndex: 'id'
        // },
        {
          title: '项目名称',
          width: '350px',
          dataIndex: 'projectName'
          // dataIndex: 'projectId'
        },
        {
          title: '项目经理',
          dataIndex: 'projectManager'
        },
        {
          title: '资料员',
          dataIndex: 'dataPerson'
        },
        {
          title: '施工员',
          dataIndex: 'buildPerson'
        },
        {
          title: '操作',
          align: 'center',
          width: '100px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="sys:common:prostaff:edit">
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$refs.projectStaffAddOrUpdate.init(record.projectId, 'show')
    },
    edit (record) {
      this.$refs.projectStaffAddOrUpdate.init(record.projectId, 'edit')
    },
    deleteItem (record) {
      delObj(record.projectId).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    }
  },
  created () {
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
